import { createSlice } from '@reduxjs/toolkit';

const initialProducts = [
  { id: 1, name: 'Laptop', price: 45000 },
  { id: 2, name: 'Smartphone', price: 25000 },
  { id: 3, name: 'Headphones', price: 3500 },
  { id: 4, name: 'Keyboard', price: 2500 },
  { id: 5, name: 'Mouse', price: 1200 }
];

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    products: initialProducts,
    cart: []
  },
  reducers: {
    addProduct: (state, action) => {
      state.products.push({ ...action.payload, id: Date.now() });
    },
    updateProduct: (state, action) => {
      const index = state.products.findIndex(p => p.id === action.payload.id);
      if (index !== -1) {
        state.products[index] = action.payload;
      }
    },
    removeProduct: (state, action) => {
      state.products = state.products.filter(p => p.id !== action.payload);
    },
    addToCart: (state, action) => {
      const existing = state.cart.find(item => item.id === action.payload.id);
      if (existing) {
        existing.quantity += 1;
      } else {
        state.cart.push({ ...action.payload, quantity: 1 });
      }
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item.id !== action.payload);
    }
  }
});

export const { addProduct, updateProduct, removeProduct, addToCart, removeFromCart } = productsSlice.actions;
export default productsSlice.reducer;